import { useQuery } from "@tanstack/react-query";
import { communicationServices } from "./communication.services";
import { PaginationParams } from "~/services";

export const useGetCommunications = (params?: PaginationParams) => {
  return useQuery({
    queryKey: ["communications", params],
    queryFn: () => communicationServices.getCommunicationHistory(params),
  });
};
